"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M21 4.434c-1.4264-.0366-2.8161-.3958-5.4298-1.1875C12.7862 2.4033 11.034 2 8.6519 2 6.7184 2 5.447 2.495 4.711 3.3912c-.695.8462-.7149 1.8321-.7154 2.3138C3.391 6.1554 3 6.8708 3 7.6763c0 .3086.0574.604.1622.8763C2.4636 8.9902 2 9.7606 2 10.6378s.4636 1.6475 1.1622 2.0852A2.4343 2.4343 0 0 0 3 13.5993c0 1.363 1.1193 2.4679 2.5 2.4679h4.8026c-.4412 1.4669-.7074 2.7536-.7442 2.9346-.2774 1.3299.5723 2.6539 1.9055 2.9428 1.3373.2897 2.5559-.5904 2.9702-1.8438.1403-.4245 1.0034-2.8805 2.3875-4.3481C17.9191 14.589 19.445 13.9123 21 13.719V4.434z"
  })];
};

exports.default = _default;